export default __webpack_public_path__ + "static/media/NSCC_logo.41db7430.png";